<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/employees">{{ $t('employee_list') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="save"><i class="fa fa-floppy-o"></i> {{ $t('save') }}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('khmer_name') }}</label>
                                        <div><input class="form-control form-control-sm" type="text" v-model="model.KhmerName" /></div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('latin_name')}}</label>
                                        <div><input class="form-control form-control-sm" type="text" v-model="model.LatinName" /></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('sex')}}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.Sex">
                                                <option value="M">{{$t('male')}}</option>
                                                <option value="F">{{$t('female')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('dob')}}</label>
                                        <div>
                                            <input type="date" class="form-control form-control-sm" v-model="model.Dob" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('phone')}}</label>
                                        <div><input type="text" class="form-control form-control-sm" v-model="model.Phone" /></div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('email')}}</label>
                                        <div><input type="email" class="form-control form-control-sm" v-model="model.Email" /></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('join_date')}}</label>
                                        <div><input type="date" class="form-control form-control-sm" v-model="model.JoinDate" /></div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{ $t('confirm_date') }}</label>
                                        <div>
                                            <input type="date" class="form-control form-control-sm" v-model="model.ConfirmDate" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="blue col-form-label">{{ $t('address')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="model.Address" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('type')}}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.Type">
                                                <option value="Resident">{{$t('resident')}}</option>
                                                <option value="Non Resident">{{$t('non_resident')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('marintal_status')}}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.MarintalStatus" @change="marintalStatusChange">
                                                <option value="Single">{{$t('single')}}</option>
                                                <option value="Married">{{$t('married')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('children')}}</label>
                                        <div>
                                            <input type="number" class="form-control form-control-sm" v-model="model.Children" :disabled="model.MarintalStatus=='Single'" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('card_no')}}</label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="model.CardNo" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('salary')}}</label>
                                        <div>
                                            <input type="number" class="form-control form-control-sm" v-model="model.Salary" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('nationality')}}</label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="model.Nationality" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('job')}}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.Job">
                                                <option v-for="ret in positions" :key="ret.Id" :value="ret.Name">{{ret.Name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="blue col-form-label">{{$t('working_place')}}</label>
                                        <div>
                                            <select class="form-control form-control-sm" v-model="model.WorkPlaceId">
                                                <option v-for="ret in branches" :key="ret.Id" :value="ret.Id">{{ret.Name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                model: {
                    Sex: 'M',
                    MarintalStatus: 'Single',
                    Type: 'Resident',
                    Children: 0
                },
                title: this.$t('employee_create'),
                action: '/employee/save',
                positions: [],
                branches: []
            }
        },
        created() {
            this.jobList();
            this.branchList();
            let id = this.$route.params.id;
            if (id != undefined && id != null && id != '') {
                this.action = 'employee/update';
                this.findById(id);
            }
        },
        methods: {
            save() {
                var loading = this.$loading.show();
                if (this.model.MarintalStatus == 'Single') this.model.Children = 0;
                this.model.CompanyId = this.$store.state.company.Id;
                this.model.ClientId = this.$store.state.company.ClientId;

                this.$api().post(this.action, this.model).then(res => {
                    if (this.$isValid(res)) {
                        this.$router.go(-1);
                    }
                }).finally(function () { loading.hide(); });
            },
            findById(id) {
                var loading = this.$loading.show();
                this.$api().post('/employee/find', { Id: id }).then(res => {
                    if (this.$isValid(res)) {
                        this.model = res.data.Data;
                        if (this.model.Dob != null)
                            this.model.Dob = this.$format(this.model.Dob, 'YYYY-MM-DD');
                        if (this.model.JoinDate != null)
                            this.model.JoinDate = this.$format(this.model.JoinDate, 'YYYY-MM-DD');
                        if (this.model.ConfirmDate != null)
                            this.model.ConfirmDate = this.$format(this.model.ConfirmDate, 'YYYY-MM-DD');
                        this.title = this.$t('employee_update') + ' / ' + this.model.Num;
                    }
                }).finally(function () { loading.hide(); });
            },
            marintalStatusChange() {
                this.model.Children = 0;
            },
            jobList: async function () {
                var res = await this.$api().post('positions', { CompanyId: this.$store.state.company.Id });
                if (this.$isValid(res)) {
                    this.positions = res.data.Json.Positions;
                }
            },
            branchList: async function () {
                var res = await this.$api().post('branch/list', { CompanyId: this.$store.state.company.Id });
                if (this.$isValid(res)) {
                    this.branches = res.data.Json.Branches;
                }
            }
        }
    }
</script>